import React from 'react';
import './PrimaryButton.scss';
import { Link } from 'react-router-dom';

const PrimaryButton = props => {
  const buttonClasses = 'btn btn-primary primary-button btn-' + props.size;
  let button = null;

  if (!props.disabled) {
    if (props.to) {
      button = (
        <Link
          className={buttonClasses}
          to={props.to}
          onClick={props.onClick}
          disabled={props.disabled}
        >
          {props.title}
        </Link>
      );
    } else if (props.onClick) {
      button = (
        <button
          className={buttonClasses}
          onClick={props.onClick}
          disabled={props.disabled}
        >
          {props.title}
        </button>
      );
    }
  } else {
    button = (
      <button className={buttonClasses} disabled={true}>
        {props.title}
      </button>
    );
  }
  return button;
};

export default PrimaryButton;



// WEBPACK FOOTER //
// ./src/Component/PrimaryButton.js